module.exports = __webpack_public_path__ + "media/camera-top.24fe6e41.svg";